export default "__VITE_ASSET__3e4117e0__"